var _style, _rect, _g, _g2, _rect2, _rect3, _path, _defs, _g3, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftOnenote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{opacity:0.2;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{opacity:0.12;}\n\t.st4{fill:#CA64EA;}\n\t.st5{fill:#AE4BD5;}\n\t.st6{fill:#9332BF;}\n\t.st7{fill:#7719AA;}\n\t.st8{clip-path:url(#SVGID_2_);}\n\t.st9{opacity:0.48;}\n\t.st10{opacity:0.24;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    className: "st0",
    width: 512,
    height: 512
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OneNote"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_142"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ambient-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.1,48.2h311.8c10.6,0,19.4,8.6,19.4,19.4v376.7c0,10.6-8.6,19.4-19.4,19.4H152.1 c-10.6,0-19.4-8.6-19.4-19.4V67.5C132.6,56.8,141.4,48.2,152.1,48.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.1,48.2h311.8c10.6,0,19.4,8.6,19.4,19.4v376.7c0,10.6-8.6,19.4-19.4,19.4H152.1 c-10.6,0-19.4-8.6-19.4-19.4V67.5C132.6,56.8,141.4,48.2,152.1,48.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ambient-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M455,463.1H152.1c-10.6,0.2-19.3-8.3-19.3-18.9l0,0c0-0.2,0-0.4,0-0.5V67.5c-0.2-10.6,8.3-19.3,18.9-19.3 l0,0h311.9c10.6-0.2,19.3,8.3,19.4,18.9v369C482.4,451,469.9,462.9,455,463.1z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 379.2,
    y: 151.9,
    className: "st5",
    width: 103.9,
    height: 103.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 379.2,
    y: 255.7,
    className: "st6",
    width: 103.9,
    height: 103.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M379.2,359.6h103.9V444c0,10.8-8.8,19.6-19.6,19.6l0,0h-84.2L379.2,359.6L379.2,359.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M152.1,48.2h311.8c10.6,0,19.4,8.6,19.4,19.4v376.7c0,10.6-8.6,19.4-19.4,19.4H152.1 c-10.6,0-19.4-8.6-19.4-19.4V67.5C132.6,56.8,141.4,48.2,152.1,48.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ambient-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.4,138.9h194.4c10.8,0,19.6,8.8,19.6,19.6v194.4c0,10.8-8.8,19.6-19.6,19.6H48.4 c-10.8,0-19.6-8.8-19.6-19.6V158.5C28.8,147.7,37.6,138.9,48.4,138.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.4,138.9h194.4c10.8,0,19.6,8.8,19.6,19.6v194.4c0,10.8-8.8,19.6-19.6,19.6H48.4 c-10.8,0-19.6-8.8-19.6-19.6V158.5C28.8,147.7,37.6,138.9,48.4,138.9z"
  }))))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M48.4,138.9h194.4c10.8,0,19.6,8.8,19.6,19.6v194.4c0,10.8-8.8,19.6-19.6,19.6H48.4 c-10.8,0-19.6-8.8-19.6-19.6V158.5C28.8,147.7,37.6,138.9,48.4,138.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.8,192.4h26.3l51.1,84.1c2,2.9,3.8,5.9,5.2,9l0,0c-0.4-5.8-0.4-11.5,0-17.3v-75.8h23v126.7h-24.8 L120,232.7c-2-2.7-3.6-5.8-4.9-8.8l0,0c0.4,6.3,0.4,12.6,0,18.9v76.3h-23L92.8,192.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftOnenote);
export default __webpack_public_path__ + "static/media/microsoft-onenote.9657ba4f73d279ae72632b9e7a4647cb.svg";
export { ForwardRef as ReactComponent };